import React, { useEffect } from "react";
import styled from "styled-components";
import { useAsyncFn } from "react-use";

// Components
import { ProductPrice } from "./product-price";

const ProductDetailsContainer = styled.div`
  margin: 10px 0 0 0;

  & h3,
  & p {
    font-size: 13px;
    line-height: 19px;
    letter-spacing: 0.02em;
    margin: 0;

    @media (max-width: 768px) {
      font-size: 11px;
      line-height: 15px;
    }
  }

  & .sale-price {
    margin-left: 10px;
  }
`;

// Cache for material data
const materialCache = new Map();

export const ProductDetails = ({ product }) => {
  // Check if we have direct metafield access
  const directMaterialMetafield = product?.metafields?.find(
    (field) => field.key === "materials"
  );

  // If no direct metafield access, fetch it
  const [materialData, getMaterial] = useAsyncFn(async (id) => {
    // Check cache first
    if (materialCache.has(id)) {
      return materialCache.get(id);
    }

    const response = await fetch(`/.netlify/functions/get-product-material`, {
      method: "POST",
      body: JSON.stringify({
        id: id,
      }),
      headers: new Headers({
        "Content-Type": "application/json",
      }),
    });

    const result = await response.json();
    // Cache the result
    materialCache.set(id, result);
    return result;
  }, []);

  useEffect(() => {
    if (!directMaterialMetafield && product?.admin_graphql_api_id) {
      getMaterial(product.admin_graphql_api_id);
    }
  }, [product?.admin_graphql_api_id, directMaterialMetafield]);

  if (product === null) return null;

  const price = product.variants
    .map((variant) => parseInt(variant.price))
    .sort();

  const salePrice = product.variants
    .map((variant) => variant.compare_at_price)
    .sort();

  const materialValue =
    directMaterialMetafield?.value || materialData.value?.material?.[0] || null;

  return (
    <ProductDetailsContainer className="product-details-container">
      <h3 className="uppercase">{product.title}</h3>
      <p className="materials cardo-italic">{materialValue}</p>
      <p className="price">
        <ProductPrice price={price[0]} salePrice={salePrice[0]} />
      </p>
    </ProductDetailsContainer>
  );
};
